export default {
    getSurveyChoice() {
        try{
            return localStorage.getItem('user.izbl.surveychoice');
        } catch(ex){
            return null;
        }
    },
    setSurveyChoice(value) {
        try{
            localStorage.setItem('user.izbl.surveychoice', value);
        }catch(ex){
            return null;
        }
             
    }
};